import {Matrix4,Quaternion,Vector3} from 'three';

const position=new Vector3(),scale=new Vector3(),axis=new Vector3(),rotation=new Quaternion(),delta=new Quaternion(),matrix=new Matrix4(),inverse=new Matrix4();
/** Semantic world-axis rotation on an authored bone, preserving its position and scale. */
export function rotateAuthoredBone(bone,placement,localAxis,angle){
 if(!bone?.isBone||!Number.isFinite(angle)||!localAxis?.isVector3)throw new Error('Invalid authored attention transform');
 if(Math.abs(angle)<1e-12)return;
 bone.matrixWorld.decompose(position,rotation,scale);axis.copy(localAxis).transformDirection(placement.matrixWorld);delta.setFromAxisAngle(axis,angle);rotation.premultiply(delta);
 matrix.compose(position,rotation,scale);bone.matrixAutoUpdate=false;bone.matrix.multiplyMatrices(inverse.copy(bone.parent.matrixWorld).invert(),matrix);bone.updateMatrixWorld(true);
}
